module.exports = __webpack_public_path__ + "static/tree-r-6bcd552d5f952f05df7b98ebb707f3e6.png";